import { render, staticRenderFns } from "./legal-user-account.vue?vue&type=template&id=ff4819ee&"
import script from "./legal-user-account.vue?vue&type=script&lang=js&"
export * from "./legal-user-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports